import { createAction, handleActions } from 'redux-actions';
import { api } from "api";
import { initialize as initializeForm } from "redux-form";
import { NotificationManager } from "react-notifications";
import { push } from "react-router-redux";

const LOADER = 'LOADER_PAGOS';
const DATA = 'DATA_PAGOS';
const ITEM_DATA = 'ITEM_PAGOS';
const PAGE = 'PAGE_PAGOS';
const ORDERING = 'ORDERING_PAGOS';
const SEARCH = 'SEARCH_PAGOS';

// -----------------------------------
// Pure Actions
// -----------------------------------

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setData = data => ({
    type: DATA,
    data,
});

const setItem = item => ({
    type: ITEM_DATA,
    item,
});

const setPage = page => ({
    type: PAGE,
    page,
});

const setOrdering = ordering => ({
    type: ORDERING,
    ordering,
});

const setSearch = search => ({
    type: SEARCH,
    search,
});

// ------------------------------------
// Actions
// ------------------------------------
const crear = data => (dispatch) => {
    dispatch(setLoader(true));
    api.post('payment_history', data).then(() => {
        NotificationManager.success('Registro creado', 'Éxito', 3000);
        dispatch(cleanForm()); // Limpiar el formulario
        dispatch(push(`/garage/${data.garage}/payments`));
    }).catch((error) => {
        let mensaje = 'Error en la creación, vuelve a intentarlo';
        if (error) {
            if (error.detail)
                mensaje = error.detail;
        }
        NotificationManager.error(mensaje, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const leer = (id, idGarage = 0) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${'payment_history'}/${(id)}`).then((response) => {
        if (idGarage != response.garage) {
            return <Redirect to={`"/`} />;
        }
        dispatch(setItem(response));
        dispatch(initializeForm('PagoForm', response));
    }).catch(() => {
        dispatch(push('/'));
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const listar = (page = 1, idGarage = 0) => (dispatch, getStore) => {
    const resource = getStore().pagos;
    const params = { page, garage_id: idGarage };

    if (resource.ordering)
        params.ordering = resource.ordering;
    if (resource.search)
        params.search = resource.search;

    dispatch(setLoader(true));
    api.get('payment_history', params).then((response) => {
        dispatch(setData(response));
        dispatch(setPage(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`payment_history/${id}`, data)
        .then(() => {
            NotificationManager.success('Registro actualizado', 'Éxito', 3000);
            dispatch(push(`/garage/${data.garage}/branches`));
        })
        .catch((error) => {
            let mensaje = 'Error en la edición, vuelve a intentarlo';
            if (error) {
                if (error.detail)
                    mensaje = error.detail;
            }
            NotificationManager.error(mensaje, 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};


const eliminar = (id, idGarage) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`payment_history/${id}`).then(() => {
        dispatch(listar(1, idGarage));
        NotificationManager.success('Registro eliminado', 'Éxito', 3000);
    }).catch((error) => {
        let mensaje = 'No se puede eliminar un pago de un mes ya cerrado';
        if (error) {
            if (error.detail)
                mensaje = error.detail;
        }
        NotificationManager.error(mensaje, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const cleanForm = () => (dispatch) => {
    dispatch(initializeForm('PagoForm', {}));
};

const searchChange = (search, idGarage) => (dispatch, getStore) => {
    dispatch(setSearch(search));
    dispatch(listar(1, idGarage));
};

const onSortChange = (ordering, idGarage) => (dispatch, getStore) => {
    const sort = getStore().pagos.ordering;
    if (ordering === sort) {
        dispatch(setOrdering(`-${ordering}`));
    } else {
        dispatch(setOrdering(ordering));
    }
    dispatch(listar(1, idGarage));
};

export const actions = {
    listar,
    leer,
    crear,
    editar,
    eliminar,
    searchChange,
    onSortChange,
    cleanForm,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [ORDERING]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [SEARCH]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
};

export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    page: 1,
    ordering: '',
    search: '',
};

export default handleActions(reducers, initialState);
